import React, { useContext } from 'react'
import { Upselling } from '../../components/upselling/upselling'
import { FeatureContext } from '../../context/useFeatureFlagContext'
import { useNavigate } from 'react-router-dom'
import { useUpselling } from '../../hooks/useUpselling'

export function Ecommerce() {
    const upselling = useUpselling()

    const navigate = useNavigate()

    const { features } = useContext(FeatureContext)

    const handlerGoHome = () => {
        upselling.updateUpselling('amimarket', true)
        navigate('/')
    }

    return (
        <Upselling
            active={features.amimarket}
            feature={{
                image: require('../../assets/images/upselling/ecommerce.png'),
                title: 'Ya tienes acceso\na tu e-commerce',
                btn: {
                    title: 'Volver al Inicio',
                    action: () => {
                        handlerGoHome()
                    },
                },
            }}
            pending={{
                headtitle: 'Tu E-commerce',
                title: 'Puedes tener tu E-commerce',
                text: 'Lanza tu tienda online en minutos con amiPOS y abre tu negocio al mundo digital. Fácil configuración, sin necesidad de conocimientos técnicos. ¡Con un e-commerce, tu restaurante llega más lejos sin tener que mover una sola mesa!',
                list: [
                    'Vende a cualquier hora, tu comercio puede estar abierto 24/7',
                    'Menos clientes en el local, pero más clientes comprando',
                    'Gestiona tu tienda online sin esfuerzo desde amiPOS',
                    'Puedes cobrar con todos los  medios de pago online',
                    'No necesitas saber nada de programación ni contratar a nadie para tener la tienda, amiPOS hace todo',
                ],
                // btn1: {
                //     title: 'Contratar',
                //     action: () => {
                //         navigate('/subscription')
                //     },
                // },
                btn2: {
                    title: 'Hablar con Ventas',
                    action: () => {
                        window.open(
                            'https://amipass.typeform.com/to/BcTVDWHf?typeform-source=amipass.atlassian.net',
                            '_blank'
                        )
                    },
                },
                image: require('../../assets/images/upselling/ecommerce.png'),
                contract: 'contratando el Plan Pro',
            }}
        />
    )
}
